import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=745d9874"
import script from "./Issues.vue?vue&type=script&lang=ts"
export * from "./Issues.vue?vue&type=script&lang=ts"
import style0 from "./Issues.vue?vue&type=style&index=0&id=745d9874&lang=scss"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745d9874')) {
      api.createRecord('745d9874', component.options)
    } else {
      api.reload('745d9874', component.options)
    }
    module.hot.accept("./Issues.vue?vue&type=template&id=745d9874", function () {
      api.rerender('745d9874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Issues.vue"
export default component.exports